import { blogPosts, type BlogPost } from '@/lib/blogData';
import { getBlogCanonicalSlug } from '@/lib/blogSlugs';
import { computeReadingTimeI18n } from '@/lib/blogReadingTime';
import type { WebsiteBlogPost } from '@/lib/contentService';

function buildMarkdown(post: BlogPost, lang: 'tr' | 'en') {
  const parts = [post.intro[lang]];
  for (const section of post.sections) {
    parts.push(`## ${section.heading[lang]}`, ...section.paragraphs[lang]);
  }
  return parts.join('\n\n').trim();
}

export function staticBlogPostToWebsitePost(post: BlogPost): WebsiteBlogPost {
  const contentTr = buildMarkdown(post, 'tr');
  const contentEn = buildMarkdown(post, 'en');

  return {
    id: post.id,
    slug: post.slug,
    title: post.title.tr,
    title_i18n: post.title,
    excerpt: post.excerpt.tr,
    excerpt_i18n: post.excerpt,
    intro_i18n: post.intro,
    content: contentTr,
    content_i18n: { tr: contentTr, en: contentEn },
    cover_image: null,
    category: post.category.tr,
    category_i18n: post.category,
    tags: post.tags ?? [],
    author_name: 'Figtures',
    seo_title: post.title.tr,
    seo_title_i18n: post.title,
    seo_description: post.seoDescription.tr,
    seo_description_i18n: post.seoDescription,
    reading_time_i18n: computeReadingTimeI18n({ tr: contentTr, en: contentEn }),
    og_image: null,
    published_at: post.publishedIso,
    created_at: post.publishedIso,
  };
}

export function getStaticBlogPosts(): WebsiteBlogPost[] {
  return blogPosts.map(staticBlogPostToWebsitePost);
}

export function getStaticBlogPostBySlug(slug: string): WebsiteBlogPost | null {
  const canonicalSlug = getBlogCanonicalSlug(slug);
  const post = blogPosts.find((entry) => entry.slug === canonicalSlug);
  return post ? staticBlogPostToWebsitePost(post) : null;
}
